import { RoutePaths } from '@interfaces/routePaths'
import { SettingsLayout } from '../SettingsLayout'
import { Base } from '@views/AccountSettings/Base'
import { PersonalInfo } from '@views/AccountSettings/PersonalInfo'
import { Security } from '@views/AccountSettings/Security'
import { Privacy } from '@views/AccountSettings/Privacy'
import { PrivacySettings } from '@views/AccountSettings/PrivacySettings'
import { Notifications } from '@views/AccountSettings/Notifications'

export const ACCOUNT_SETTINGS = [
  {
    path: RoutePaths.ACCOUNT_SETTINGS,
    element: <SettingsLayout type="account" />,
    children: [
      {
        path: RoutePaths.ACCOUNT_SETTINGS_PERSONAL_INFO,
        element: (
          <Base>
            <PersonalInfo />
          </Base>
        ),
      },
      {
        path: RoutePaths.ACCOUNT_SETTINGS_SECURITY,
        element: (
          <Base>
            <Security />
          </Base>
        ),
      },
      {
        path: RoutePaths.ACCOUNT_SETTINGS_NOTIFICATIONS,
        element: (
          <Base>
            <Notifications />
          </Base>
        ),
      },
      {
        path: RoutePaths.ACCOUNT_SETTINGS_PRIVACY,
        element: (
          <Base>
            <Privacy />
          </Base>
        ),
        children: [
          {
            path: RoutePaths.ACCOUNT_SETTINGS_PRIVACY_PROSPECTIVE_CONTACTS,
            element: (
              <PrivacySettings
                route={RoutePaths.ACCOUNT_SETTINGS_PRIVACY_PROSPECTIVE_CONTACTS}
              />
            ),
          },
          {
            path: RoutePaths.ACCOUNT_SETTINGS_PRIVACY_CONTACTS,
            element: (
              <PrivacySettings
                route={RoutePaths.ACCOUNT_SETTINGS_PRIVACY_CONTACTS}
              />
            ),
          },
          {
            path: RoutePaths.ACCOUNT_SETTINGS_PRIVACY_COMMUNITY_PARTNERS,
            element: (
              <PrivacySettings
                route={RoutePaths.ACCOUNT_SETTINGS_PRIVACY_COMMUNITY_PARTNERS}
              />
            ),
          },
        ],
      },
    ],
  },
]
